<div class="po-row np">
  <po-lookup #lookupInsumos
  class="np po-xl-12 po-lg-12 po-md-12 po-sm-12" [p-columns]="columns"
  [p-disabled]="properties.includes('disabled')" [p-field-label]="fieldLabel" [p-field-value]="fieldValue"
  [p-field-format]="fieldFormat" [p-filter-service]="filterService || inputLookupService"
  [p-filter-params]="fieldLabel" [p-help]="help" [p-literals]="customLiterals" [p-no-autocomplete]="true"
  [p-optional]="properties.includes('optional')" [p-required]="properties.includes('required')"
  (p-error)="changeEvent($event)" (p-selected)="changeEvent($event)">
 </po-lookup>
</div>

<div style="position: relative;margin-top: 1.5em;"
     class="np po-xl-12 po-lg-12 po-md-12 po-sm-12"
     *ngIf="inputLookupService.IsSearching">
  <po-loading-overlay *ngIf="inputLookupService.IsSearching" ></po-loading-overlay>
</div>

<div [hidden]="contextApplication.hiddenDashboardTaskInput[1]">
  <div class="po-row np">
    <p class="insumoTitle npl po-xl-1 po-lg-1 po-md-1 po-sm-1 np" style="width: 4%">{{ literalsCp?.strInsumo | uppercase }}</p>
    <hr class="po-xl-11 po-lg-11 po-md-11 po-sm-11" style="margin-top: 30px;margin-left: 12px; width: 90%" />
  </div>

  <div class="po-row">
    <div class="circuloInsumo po-xl-1 po-lg-1 po-md-1 po-sm-1"><span class="po-icon po-icon-stock iconMiddle"
        style="font-size: 20px;"></span></div>
    <span class="insumoDescripton po-xl-11 po-lg-11 po-md-11 po-sm-11">{{ inputInfo.description }}</span>
  </div>

  <div class="po-row" style="padding-left: 4px;">
    <p class="inputCode po-page-content np po-xl-12 po-lg-12 po-md-12 po-sm-12">{{ literalsCp?.strCod | uppercase }} {{ inputInfo.inputCode }}</p>
  </div>

  <cp-inputcharts name="inputChartsDashboard" [inputInfo]="inputInfo"></cp-inputcharts>

  <cp-inputtasks #inputtasks [InputItem]="inputInfo"></cp-inputtasks>
</div>

